/* ============================================================
   TOTALLY BAKED — GROOVE ROOM THEME
   Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ── HEADER SCROLL BEHAVIOR ── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ── ACTIVE NAV LINK ── */
  const navLinks = document.querySelectorAll('.header-nav a');
  navLinks.forEach(link => {
    if (link.href === window.location.href ||
        (link.pathname !== '/' && window.location.pathname.startsWith(link.pathname))) {
      link.classList.add('active');
    }
  });

  /* ── MOBILE MENU ── */
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileNav  = document.querySelector('.mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = mobileNav.classList.toggle('open');
      menuToggle.classList.toggle('open', isOpen);
      menuToggle.setAttribute('aria-expanded', isOpen);
    });
  }

  /* ── TICKER DUPLICATION (ensure seamless loop) ── */
  document.querySelectorAll('.ticker-track').forEach(track => {
    const clone = track.innerHTML;
    track.innerHTML = clone + clone; // duplicate for seamless loop
  });

  /* ── ANNOUNCEMENT BAR CLOSE ── */
  const announcementClose = document.querySelector('.announcement-close');
  const announcementBar   = document.querySelector('.announcement-bar');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.maxHeight = announcementBar.scrollHeight + 'px';
      requestAnimationFrame(() => {
        announcementBar.style.transition = 'max-height 0.4s ease, opacity 0.3s ease';
        announcementBar.style.maxHeight  = '0';
        announcementBar.style.opacity    = '0';
        announcementBar.style.overflow   = 'hidden';
      });
      sessionStorage.setItem('tb_announcement_closed', '1');
    });
    if (sessionStorage.getItem('tb_announcement_closed')) {
      announcementBar.style.display = 'none';
    }
  }

  /* ── CATALOG FILTER BUTTONS ── */
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('[data-filter-group]');
      if (group) group.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('[data-filter-tag]').forEach(card => {
        if (filter === 'all' || card.dataset.filterTag === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* ── WHOLESALE FORM CHECKBOXES ── */
  document.querySelectorAll('.form-checkbox-label').forEach(label => {
    const input = label.querySelector('input[type="checkbox"]');
    if (!input) return;
    input.addEventListener('change', () => {
      label.classList.toggle('checked', input.checked);
    });
    // init state
    label.classList.toggle('checked', input.checked);
  });

  /* ── WHOLESALE FORM VALIDATION ── */
  const wholesaleForm = document.querySelector('#wholesale-application');
  if (wholesaleForm) {
    wholesaleForm.addEventListener('submit', function (e) {
      const required = wholesaleForm.querySelectorAll('[required]');
      let valid = true;
      required.forEach(field => {
        field.classList.remove('error');
        if (!field.value.trim()) {
          field.classList.add('error');
          valid = false;
        }
      });
      if (!valid) {
        e.preventDefault();
        const firstError = wholesaleForm.querySelector('.error');
        if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  }

  /* ── CONTACT FORM ── */
  const contactForm = document.querySelector('#contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      const required = contactForm.querySelectorAll('[required]');
      let valid = true;
      required.forEach(field => {
        field.classList.remove('error');
        if (!field.value.trim()) {
          field.classList.add('error');
          valid = false;
        }
      });
      if (!valid) e.preventDefault();
    });
  }

  /* ── SMOOTH SCROLL ── */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── INTERSECTION OBSERVER (fade-in animations) ── */
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
  } else {
    document.querySelectorAll('.fade-in').forEach(el => el.classList.add('visible'));
  }

  /* ── STATS COUNTER ANIMATION ── */
  function animateCounter(el, target, duration) {
    const start = performance.now();
    const startVal = 0;
    const isDecimal = target % 1 !== 0;
    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = startVal + (target - startVal) * eased;
      el.textContent = isDecimal ? current.toFixed(1) : Math.floor(current).toLocaleString();
      if (progress < 1) requestAnimationFrame(update);
      else el.textContent = isDecimal ? target.toFixed(1) : target.toLocaleString();
    }
    requestAnimationFrame(update);
  }

  if ('IntersectionObserver' in window) {
    const statsObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-count]').forEach(el => {
            const target = parseFloat(el.dataset.count);
            animateCounter(el, target, 1800);
          });
          statsObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });
    const statsBand = document.querySelector('.stats-band');
    if (statsBand) statsObserver.observe(statsBand);
  }

  /* ── LAB RESULTS SEARCH ── */
  const labSearch = document.querySelector('#lab-search');
  if (labSearch) {
    labSearch.addEventListener('input', () => {
      const query = labSearch.value.toLowerCase();
      document.querySelectorAll('.lab-card').forEach(card => {
        const text = card.textContent.toLowerCase();
        card.style.display = text.includes(query) ? '' : 'none';
      });
    });
  }

  /* ── B2B GATE: Redirect to login on restricted actions ── */
  document.querySelectorAll('[data-requires-login]').forEach(el => {
    el.addEventListener('click', function (e) {
      const isLoggedIn = document.documentElement.dataset.customerLoggedIn === 'true';
      if (!isLoggedIn) {
        e.preventDefault();
        const redirect = el.dataset.redirect || window.location.href;
        window.location.href = '/account/login?return_url=' + encodeURIComponent(redirect);
      }
    });
  });

  /* ── SCROLL PROGRESS BAR (articles) ── */
  const progressBar = document.querySelector('.read-progress');
  if (progressBar) {
    window.addEventListener('scroll', () => {
      const scrollTop  = window.scrollY;
      const docHeight  = document.body.scrollHeight - window.innerHeight;
      const progress   = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
      progressBar.style.width = Math.min(progress, 100) + '%';
    }, { passive: true });
  }

  /* ── STICKY HEADER OFFSET FOR ANCHOR LINKS ── */
  function setAnchorOffset() {
    const hdr = document.querySelector('.site-header');
    if (hdr) {
      document.documentElement.style.setProperty(
        '--header-height',
        hdr.offsetHeight + 'px'
      );
    }
  }
  setAnchorOffset();
  window.addEventListener('resize', setAnchorOffset);

})();
